import { useCallback } from 'react'
import { useIntl } from 'react-intl'

import AssistChip from 'LuxKit/Chips/AssistChip'
import LineBedIcon from 'LuxKit/Icons/line/LineBedIcon'
import LineCameraPlusIcon from 'LuxKit/Icons/line/LineCameraPlusIcon'
import LinePlaneFlyIcon from 'LuxKit/Icons/line/LinePlaneFlyIcon'
import type { TripStop } from 'tripPlanner/api/types'

const HOTELS_ICON = <LineBedIcon />
const FLIGHTS_ICON = <LinePlaneFlyIcon />
const EXPERIENCES_ICON = <LineCameraPlusIcon />

interface Props {
  stop: TripStop
  disabled?: boolean
  onOpenStopHotels: (stop: TripStop) => void
  onOpenStopFlights: (stop: TripStop) => void
  onOpenStopExperiences: (stop: TripStop) => void
}

function StopSearchActions({
  stop,
  disabled = false,
  onOpenStopHotels,
  onOpenStopFlights,
  onOpenStopExperiences,
}: Props) {
  const intl = useIntl()
  const handleOpenHotels = useCallback(() => {
    onOpenStopHotels(stop)
  }, [onOpenStopHotels, stop])
  const handleOpenFlights = useCallback(() => {
    onOpenStopFlights(stop)
  }, [onOpenStopFlights, stop])
  const handleOpenExperiences = useCallback(() => {
    onOpenStopExperiences(stop)
  }, [onOpenStopExperiences, stop])

  return <>
    <AssistChip variant="outline" size="small" startIcon={HOTELS_ICON} onClick={handleOpenHotels} disabled={disabled}>
      {intl.formatMessage({
        id: 'We7fUT83Jfm51bWv50xl',
        defaultMessage: 'Hotels',
        description: 'Button label on a stop row in the trip planner list view that opens the hotel search for that stop',
      })}
    </AssistChip>
    <AssistChip variant="outline" size="small" startIcon={FLIGHTS_ICON} onClick={handleOpenFlights} disabled={disabled}>
      {intl.formatMessage({
        id: '6u3y7Th34cT-hPjMNLGp',
        defaultMessage: 'Flights',
        description: 'Button label on a stop row in the trip planner list view that opens the flight search for that stop',
      })}
    </AssistChip>
    <AssistChip variant="outline" size="small" startIcon={EXPERIENCES_ICON} onClick={handleOpenExperiences} disabled={disabled}>
      {intl.formatMessage({
        id: '1W9kjs9puIMc4FXxa867',
        defaultMessage: 'Things to do',
        description: 'Button label on a stop row in the trip planner list view that opens the things to do search for that stop',
      })}
    </AssistChip>
  </>
}

export default StopSearchActions
